/* eslint-disable */
import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function sendInviteStaff(id: string, email: string) {
	error.value = null;
	try {
		const res = await $api.staff.sendInviteStaff(id, {
			email: email,
		});
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
		return err?.response?.data;
	} finally {
		loading.value = false;
	}
}

export function useSendInviteStaff() {
	return { sendInviteStaff__error: error, loading, sendInviteStaff };
}
